export default {
  queriedTasks: state => state.tasks.filter((task) => {
    return task.status !== 'Deleted' && (task.activity.toLowerCase().includes(state.todoSearchQuery.toLowerCase()));
  }),
  getTask: state => taskId => state.tasks.find((task) => task.key === taskId)
  // getTodosBySection: state => (sectionId) => state.todoArray.filter((task) => task.sectionId == sectionId),
};
